// Dados iniciais mockados para demonstração (estados)
export const initialStatesData = [
    { id: "AC", state: "Acre", region: "Norte", value: 85 },
    { id: "AL", state: "Alagoas", region: "Nordeste", value: 45 },
    { id: "AM", state: "Amazonas", region: "Norte", value: 70 },
    { id: "AP", state: "Amapá", region: "Norte", value: 90 },
    { id: "BA", state: "Bahia", region: "Nordeste", value: 60 },
    { id: "CE", state: "Ceará", region: "Nordeste", value: 35 },
    { id: "DF", state: "Distrito Federal", region: "Centro-Oeste", value: 95 },
    { id: "ES", state: "Espírito Santo", region: "Sudeste", value: 25 },
    { id: "GO", state: "Goiás", region: "Centro-Oeste", value: 40 },
    { id: "MA", state: "Maranhão", region: "Nordeste", value: 55 },
    { id: "MG", state: "Minas Gerais", region: "Sudeste", value: 30 },
    { id: "MS", state: "Mato Grosso do Sul", region: "Centro-Oeste", value: 65 },
    { id: "MT", state: "Mato Grosso", region: "Centro-Oeste", value: 50 },
    { id: "PA", state: "Pará", region: "Norte", value: 80 },
    { id: "PB", state: "Paraíba", region: "Nordeste", value: 20 },
    { id: "PE", state: "Pernambuco", region: "Nordeste", value: 75 },
    { id: "PI", state: "Piauí", region: "Nordeste", value: 40 },
    { id: "PR", state: "Paraná", region: "Sul", value: 15 },
    { id: "RJ", state: "Rio de Janeiro", region: "Sudeste", value: 60 },
    { id: "RN", state: "Rio Grande do Norte", region: "Nordeste", value: 85 },
    { id: "RO", state: "Rondônia", region: "Norte", value: 70 },
    { id: "RR", state: "Roraima", region: "Norte", value: 100 },
    { id: "RS", state: "Rio Grande do Sul", region: "Sul", value: 55 },
    { id: "SC", state: "Santa Catarina", region: "Sul", value: 30 },
    { id: "SE", state: "Sergipe", region: "Nordeste", value: 45 },
    { id: "SP", state: "São Paulo", region: "Sudeste", value: 75 },
    { id: "TO", state: "Tocantins", region: "Norte", value: 90 }
  ];